import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/** 로그인된 사용자는 목적지로 자동 이동 (기본 /catalog). Landing/Login/Signup 감쌀 때 사용. */
export default function GuestOnly({ children, to }: { children: ReactNode; to?: string }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    const dest = user.role === "admin" ? "/admin" : user.status === "approved" ? "/catalog" : (to ?? "/account");
    return <Navigate to={dest} replace />;
  }
  return <>{children}</>;
}
